/**
 * 工厂反馈
 * */
import React from 'react';
import Lang from "@components/Lang/Lang";
import ExceptionPendingOrderAction from '../ExceptionPendingOrder.action';
import "./index.less";
import Locale from "@utils/locale";
import {Spin} from "antd";
class Feedback extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            abnormalItem:props.abnormalItem,
            isShowTranslate:false,
            abnormalTranslateValue:'',
            loading:false,
        }
    }
    /**
     * 翻译
     */
    translate(answerZh){
        if(this.state.abnormalTranslateValue){
            this.setState({
                isShowTranslate:!this.state.isShowTranslate
            })
        }else{
            const data = {
                sourceList:[answerZh],
                // targetLang: Locale.current()
                targetLangs: [Locale.current()],
                useModel:'common',//使用翻译模式（(common.通用翻译模型 goods.商品翻译模型)）
                remark:window.location.href,
            }
            this.loading(true);
            ExceptionPendingOrderAction.getTranslate(data).then(res=>this.handleRes(res.data)).catch(err=>this.handleRes(err))
        }

    }
    handleRes(res){
        this.loading(false);
        const {success,valid} = res;
        if(success&&valid){
            this.setState({
                isShowTranslate:!this.state.isShowTranslate,
                abnormalTranslateValue:res.models[0].translatedText
            })
        }
    }
    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    componentWillReceiveProps(nextProps){
        this.state.abnormalItem = nextProps.abnormalItem;
    }
    render(){
        let {abnormalItem,isShowTranslate,abnormalTranslateValue,loading} = this.state;
        return (<Spin spinning={loading}>
            <div className="feedbackAbnormal">
                <p className="title">{Lang({id: 'GongChangFanKui', default: '工厂反馈'})}</p>

                <div className="feedback-item">
                    {abnormalItem.abnormalValue}
                </div>

                <a className="translate" onClick={this.translate.bind(this,abnormalItem.abnormalValue)}>
                    <span className = "iconfont icon-translate"></span>
                    <span>{Lang({id: 'FanYi', default: '翻译'})}</span>
                </a>

                {isShowTranslate?<div className="feedback-translate-content">{abnormalTranslateValue}</div>:null}
            </div>
            </Spin>
        )
    }
}

export default Feedback;
